import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '../stores/storeUser';
// import AboutView from '../views/AboutView.vue'
import LoginView from '../views/LoginView.vue'
import LogoutView from '../views/LogoutView.vue'
import AdminMunicipalityView from '../views/AdminMunicipalityView.vue'
import AdminSchoolView from '../views/AdminSchoolView.vue'
import StudentView from '../views/StudentView.vue'
import GuardianView from '../views/GuardianView.vue'
import GuardianLoginView from '../views/GuardianLoginView.vue'
import PrintView from '../views/PrintView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import DemoView from '../views/DemoView.vue'
import PolicyView from '../views/PolicyView.vue'
import MainView from '../views/MainView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'main',
      meta: {
        title: "Velkommen",
        requiresAuth: false,
      },
      component: () => import('../views/MainView.vue'),
    },
    {
      path: '/policy',
      name: 'policy',
      meta: {
        title: "Personvern",
        requiresAuth: false,
      },
      component: () => import('../views/PolicyView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: "Login",
        requiresAuth: false,
      },
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      meta: {
        title: "Logg ut",
        requiresAuth: true,
      },
      component: () => import('../views/LogoutView.vue'),
    },
    {
      path: '/admin/municipality',
      name: 'adminMunicipality',
      meta: {
        title: "Kommune administrasjon",
        requiresAuth: true,
      },
      component: () => import('../views/AdminMunicipalityView.vue'),
    },
    {
      path: '/admin/school/:schoolID',
      name: 'adminSchool',
      meta: {
        title: "Skole administrasjon",
        requiresAuth: true,
      },
      component: () => import('../views/AdminSchoolView.vue'),
    },
    {
      path: '/student',
      name: 'student',
      meta: {
        title: "Prioriter",
        requiresAuth: true,
      },
      component: () => import('../views/StudentView.vue'),
    },
    {
      path: '/guardian/:schoolID/:guardianCode',
      name: 'guardian',
      meta: {
        title: "",
        requiresAuth: false,
      },
      component: () => import('../views/GuardianView.vue'),
    },
    {
      path: '/guardian/',
      name: 'guardianLogin',
      meta: {
        title: "",
        requiresAuth: false,
      },
      component: () => import('../views/GuardianLoginView.vue'),
    },
    {
      path: '/print/:type/:schoolID/:subjectID',
      name: 'print',
      meta: {
        title: "Skrive ut liste",
        requiresAuth: true,
      },
      component: () => import('../views/PrintView.vue'),
    },
    {
      path: '/demo/:type',
      name: 'demo',
      meta: {
        title: "Demo",
        requiresAuth: false,
      },
      component: () => import('../views/DemoView.vue'),
    },
    {
      path: '/demo',
      name: 'demoView',
      meta: {
        title: "Demo",
        requiresAuth: false,
      },
      component: () => import('../views/DemoView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'Ukjent side',
      meta: {
        title: "Not Found",
        requiresAuth: false,
      },
      component: () => import('../views/NotFoundView.vue'),
    },
  ],
})
router.beforeEach((to, from, next) => {
  const user = useUserStore();
  // claenup modal
  // check if body have modal-open class and remove it
  if (document.body.classList.contains('modal-open')) {
    document.body.classList.remove('modal-open');
  }
  // check if body have modal-backdrop class and delete element
  if (document.body.contains(document.querySelector('.modal-backdrop'))) {
    document.querySelector('.modal-backdrop').remove();
  }

  // Get the page title from the route meta data that we have defined
  // See further down below for how we setup this data
  const title = to.meta.title + "";
  // If the route has a title, set it as the page title of the document/page
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !user.data.firstName) {
    next("/login");
  } else {
    if (title) {
      document.title = title + " - ValgSmart";
    }
    else {
      document.title = "ValgSmart";
    }
    // Continue resolving the route
    next();
  }
})

export default router
